module.exports = __webpack_public_path__ + "img/en.f2d1ea96.png";